const EDITOR_VERSION = "16.0.0";

export default EDITOR_VERSION;
